export const QUALTRICS_APP_NAME =
  'ppmenodeweb-feedbacklink-sellerdashboard-jul2021'
export const NEW_ARRIVALS_PREVIEW_TYPE = 'newArrivalProducts'
export const HARD_CODED_PRODUCTS_PREVIEW = [
  {
    id: '1',
    name: 'Double Name Ring, Two Name Ring for your love',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    price: {
      amount: '23.62',
      currencyCode: 'USD',
    },
  },
  {
    id: '2',
    name: 'Custom Name Necklace Figaro for your loved one',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-2.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '3',
    name: 'Double Name Ring, Two Name Ring for your love',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    price: {
      amount: '23.62',
      currencyCode: 'USD',
    },
  },
  {
    id: '4',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-2.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '5',
    name: 'Double Name Ring, Two Name Ring for your love',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    price: {
      amount: '23.62',
      currencyCode: 'USD',
    },
  },
  {
    id: '6',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-2.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '7',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '8',
    name: 'Double Name Ring, Two Name Ring for your love',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-2.png',
    price: {
      amount: '23.62',
      currencyCode: 'USD',
    },
  },
  {
    id: '9',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '10',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-2.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '11',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '12',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-2.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '13',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '14',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-2.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
  {
    id: '15',
    name: 'Custom Name Necklace Figaro',
    photoUrl:
      'https://uideploy--staticcontent--4d0fbe1fedb5c--ghe.preview.dev.paypalinc.com/ppme_shops/samples/earring-1.png',
    price: {
      amount: '39.95',
      currencyCode: 'USD',
    },
  },
]
